const APPENV = process.env.VUE_APP_ENV || 'development';
const HTTP_HRADER = window.location.protocol === 'http:' ? 'http:' : 'https:';
// const zone = 'b2b-scm-dev.';
const zone = ''; // 不要再配置zone 请使用代理：https://91jkys.yuque.com/hnm3gl/ldlaaz/fii5ce

const development = {
  IMAPIGW: 'QA', // im apigw
  // IM: 'b2b-scm-test.', // im zone
  IM: '', // im zone
  loginBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 登录接口（复用问诊） https://91jkys.yuque.com/hnm3gl/ze8kgn/sa70ea
  userBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // user 的baseURL
  qualificationBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 资质认证后端的baseURL
  shopBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 店铺模块后端的baseURL
  personalBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', //
  goodsBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 商品模块后端的baseURL
  orderBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 订单模块后端的baseURL
  cartBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 购物车模块后端的baseURL
  couponBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 优惠券模块后端的baseURL
  uploadBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 文件后端的baseURL
  marketBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 营销相关
  agreementBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com' // 协议相关
};

const qa = {
  IMAPIGW: 'QA', // im apigw
  // IM: 'b2b-scm-test.', // im zone
  IM: '', // im zone
  loginBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 登录接口（复用问诊） https://91jkys.yuque.com/hnm3gl/ze8kgn/sa70ea
  userBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // user 的baseURL
  qualificationBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 资质认证后端的baseURL
  shopBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 店铺模块后端的baseURL
  personalBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // （买家信息）
  goodsBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 商品模块后端的baseURL
  orderBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 订单模块后端的baseURL
  cartBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 购物车模块后端的baseURL
  couponBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 优惠券模块后端的baseURL
  uploadBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 文件后端的baseURL
  marketBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com', // 营销相关
  agreementBaseUrl: HTTP_HRADER + '//' + zone + 'apigw.qa.kminghealth.com' // 协议相关
};

const preview = {
  IMAPIGW: 'PRE', // im apigw
  IM: '', // im zone
  loginBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 登录接口（复用问诊） https://91jkys.yuque.com/hnm3gl/ze8kgn/sa70ea
  userBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // user 的baseURL
  qualificationBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 资质认证后端的baseURL
  shopBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 店铺模块后端的baseURL
  personalBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // （买家信息）
  goodsBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 商品模块后端的baseURL
  orderBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 订单模块后端的baseURL
  cartBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 购物车模块后端的baseURL
  couponBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 优惠券模块后端的baseURL
  uploadBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 文件后端的baseURL
  marketBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com', // 营销相关
  agreementBaseUrl: HTTP_HRADER + '//apigw.pre.kminghealth.com' // 协议相关
};

const production = {
  IMAPIGW: 'ONLINE', // im apigw
  IM: '', // im zone
  loginBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 登录接口（复用问诊） https://91jkys.yuque.com/hnm3gl/ze8kgn/sa70ea
  userBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // user 的baseURL
  qualificationBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 资质认证后端的baseURL
  shopBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 店铺模块后端的baseURL
  personalBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // （买家信息）
  goodsBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 商品模块后端的baseURL
  orderBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 订单模块后端的baseURL
  cartBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 购物车模块后端的baseURL
  couponBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 优惠券模块后端的baseURL
  uploadBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 文件后端的baseURL
  marketBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com', // 营销相关
  agreementBaseUrl: HTTP_HRADER + '//apigw.kminghealth.com' // 协议相关
};

const config = {
  development,
  qa,
  preview,
  production
};

export default config[APPENV];
